import axiosInstance from "./axios-order";
import Cookies from "js-cookie";
import {toast} from "react-toastify";
import {REQ_TYPES} from "../constants/global";
import {DateObject} from "react-multi-date-picker";
import gregorian_en from "react-date-object/locales/gregorian_en";
import gregorian from "react-date-object/calendars/gregorian";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";


export const fetchData = async (url = "", type = "", dataParams = {}, token = false, props = {}) => {

    const {
        isHeaderJson = false,
        isLoader = true,
        existFile = false,
        reFetchCallback = null,
        inputParams = [],
        axiosConfig = {},
        headerConfigs = {},
        baseUrl = process.env.REACT_APP_FREELANCER_PANEL_API_URL,
    } = props;

    if (!navigator.onLine) {

        toast.error('خطا در دسترسی به اینترنت');

        const reRequest = () => {
            if (typeof reFetchCallback === "function") {
                reFetchCallback();
            }
            window.removeEventListener('online', reRequest);
        }

        window.addEventListener('online', reRequest);

        return {error: true};
    }

    if (isLoader) {
        loader(true)
    }

    //Initial headers
    let header = {...headerConfigs}

    if (existFile) {
        header = {...header, "Content-Type": "multipart/form-data; boundary"}
    } else if (isHeaderJson) {
        header = {...header, "Content-Type": "application/json; charset=utf-8"}
    }

    //Generate final header
    if (token) {
        const tokenValue = Cookies.get(process.env.REACT_APP_FREELANCER_TOK);

        header = {
            headers: {
                ...header,
                Authorization: `Bearer ${tokenValue ? tokenValue : token}`
            }
        };
    } else {
        header = {
            headers: {
                ...header,
            }
        };
    }

    const requestConfig = {
        ...header,
        ...axiosConfig
    }

    if (type === REQ_TYPES.POST) {
        let formData;
        if (isHeaderJson) {
            formData = dataParams;
        } else if (existFile) {
            formData = new FormData();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        } else {
            formData = new URLSearchParams();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        }
        try {

            const {data, status} = token ? await axiosInstance.post(baseUrl + url, formData, requestConfig,
              ) : await axiosInstance.post(baseUrl + url, formData, requestConfig);

            if (isLoader) {
                loader(false);
            }
            return responseHandler(data, status, reFetchCallback, inputParams)

        } catch (errorData) {
            if (isLoader) {
                loader(false);
            }
            return responseHandler(errorData, null, reFetchCallback, inputParams)
        }

    } else {
        let formData = "?";
        for (let key in dataParams) {
            formData += formData.slice(-1) === "?" ? `${key}=${dataParams[key]}` : `&${key}=${dataParams[key]}`;
        }

        try {
            const {
                data,
                status
            } = token ? await axiosInstance.get(baseUrl + url + formData, requestConfig) :
                await axiosInstance.get(baseUrl + url + formData, requestConfig);
            if (isLoader) {
                loader(false);
            }

            return responseHandler(data, status, reFetchCallback, inputParams)

        } catch (errorData) {
            if (isLoader) {
                loader(false);
            }
            return responseHandler(errorData, null, reFetchCallback, inputParams)
        }

    }
};

const responseHandler = (data, status, reFetchCallback, inputParams) => {

    const statusCode = status || (data.response && data.response.status) || data.code;
    //After ask data.errors
    const error = data.errors || (data.response && data.response.data && data.response.data.error);

    console.log("FETCH DATA FUNC: ", data)

    if (statusCode === 200) {
        return {data, error: null};
    }

    return errorHandler(error, reFetchCallback, statusCode)

    // if (statusCode >= 400 && statusCode <= 499) {
    //     if (errors) {
    //         // errors are array and handled as array
    //         return errorMessageHandler(errors, reFetchCallback, statusCode, inputParams)
    //     } else {
    //         return errorMessageHandler("خطای ناخواسته ای پیش آمد", reFetchCallback, statusCode, inputParams, data)
    //         //خطای ناخواسته ای پیش آمد
    //     }
    // }
    //
    // return errorMessageHandler("خطای سمت سرور", reFetchCallback, statusCode, inputParams, data);


    // if (e.response.status === 401) {
    //     localStorage.removeItem(FREELANCER_TOK);
    //     window.location.replace("/login");

    // } else if (e.response.status === 403) {
    //     //Not handled
    //     for (let key in e.response.data.errors) {
    //         errorMessageHandler(e.response.data.errors[key].message)
    //     }
    //     setTimeout(() => {
    //         window.location.replace("/dashboard");
    //     }, 3000)
    // }

}

const errorHandler = async (error, reFetchCallback, statusCode) => {

    let errorMessage = "خطای ناخواسته ای پیش آمد";

    if (error && error.errors && typeof error.errors === "object" && error.errors[0]) {
        if(typeof error.errors[0] === "object" && error.errors[0].message) {
            errorMessage = error.errors[0].message;
        } else if(typeof error.errors[0] === "string"){
            errorMessage = error.errors[0];
        }
    } else if (error && typeof error.errors === "string") {
        errorMessage = error.errors;
    } else if (error && typeof error === "object" && error.message) {
        errorMessage = error.message
    }

    if (!errorCodeHandler(statusCode, reFetchCallback)) {
        toast.error(errorMessage);
    }
    return {error: error === undefined ? true : error};
    //Object or null
    // if (error) {
    //     // toast.error(error.errors.length ? error.errors[0] : message)
    //     toast.error(message)
    // } else {
    //     toast.error(message);
    // }
}

export const errorCodeHandler = (statusCode, callback = () => {}) => {
    switch (true) {
        case statusCode === 401: {
            toast.error('عدم دسترسی')
            Cookies.remove(process.env.REACT_APP_FREELANCER_TOK, {
                domain: `.${process.env.REACT_APP_MAIN_DOMAIN}`
            });
            // await Router.replace("/login")
            window.location.replace(process.env.REACT_APP_FREELANCER_LOGIN_URL);
            return true;
        }

        case statusCode === 404 : {
            // window.location.replace("/404");
            toast.error('صفحه مورد نظر پیدا نشد')
            return true;
        }

        case statusCode >= 500: {
            toast.error('خطای سمت سرور');
            DataReFetchHandler(callback);
            return true;
        }

        case statusCode === "ERR_CANCELED": {
            return true; //No need to toast
        }

        default:
            return false;
    }
}

export const DataReFetchHandler = (reFetchFunc) => {

    try {
        const reFetchContainer = document.getElementById('re-fetch-container');
        reFetchContainer.classList.remove('hidden');
        reFetchContainer.classList.add('flex');
        document.getElementById('re-fetch-btn').onclick = () => {
            typeof reFetchFunc === "function" ? reFetchFunc() : window.location.reload();
        }

        return true
    } catch (e) {
        return false
    }
}

const loader = () => {

}

export const isEmpty = (obj) => {

    if (!obj) return true;

    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }

    return JSON.stringify(obj) === JSON.stringify({});
};

export const getGregorianFormat = (date, format = "YYYY-MM-DD") => {
    try {
        const jalaliDate = new DateObject({
            date,
            calendar: persian,
            locale: persian_fa
        });
        return jalaliDate.convert(gregorian, gregorian_en).format(format)
    } catch (e) {
        toast.error("خطا در تبدیل تاریخ");
        return "";
    }
}

export const getHijriFormat = (date, format = "YYYY-MM-DD") => {
    try {
        const gregorianDate = new DateObject({
            date,
            calendar: gregorian
        });
        return gregorianDate.convert(persian, persian_fa).format(format)
    } catch (e) {
        toast.error("خطا در تبدیل تاریخ");
        return "";
    }
}

export const getPriceFormat = (price) => {
    if (!price)
        return 0;
    let result = 0;

    try {
        result = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return result;
    } catch (e) {
        toast.error("خطا در فرمت قیمت");
        return 0;
    }
}

export const getHour = (date) => {
    if(!date) {
        return ""
    }
    let hour = "";

    try {
        const time = date.split(" ")[1];
        hour = `${time.split(":")[0]}:${time.split(":")[1]}`;
    } catch (e) {
        console.log(e);
    }

    return hour;
}


export const dataURLtoFile = (dataUrl, filename) => {
    let arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bStr = atob(arr[arr.length - 1]),
        n = bStr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bStr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
}

export const getDiscountPrice = (discount, totalPrice) => {
    if (!!!Number(discount) || !!!Number(totalPrice)) {
        return 0;
    }

    return Math.round((totalPrice / 100) * discount)
}

export const getNumberWithGap = (number, gap = 2) => {
    return ("0" + number).slice(-gap);
};

export const getDiffInDays = (start, end) => {
    try {
        const date1 = new Date(start);
        const date2 = new Date(end);
        const negative = date2-date1 < 0;
        const diffTime = Math.abs(date2 - date1);
        return `${negative ? "-" : ""}${Math.ceil(diffTime / (1000 * 60 * 60 * 24))}`;
    } catch (e) {
        return ""
    }
}

export const copyToClipboard = async (textToCopy) => {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
        toast.success("لینک کپی شد!");
    } else {
        // Use the 'out of viewport hidden text area' trick
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;

        // Move textarea out of the viewport so it's not visible
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            toast.success("لینک کپی شد!");
        } catch (error) {
            toast.error("خطا در کپی کردن متن");
        } finally {
            textArea.remove();
        }
    }
}

export const removeDomain = (input, frtString = "", lstString = "") => {
    if(!input) return "";
    return frtString+input.replace(/^(https?:\/\/)?([\w-]+\.)*[\w-]+\.\w+\//, '')+lstString;
}
